import Bugsnag from '@bugsnag/js';
import { attachTraceIdToBreadcrumb } from './request-trace-ids';
import { PathNormalizer, scrubBugsnagEvent } from './scrub-bugsnag-event';

/** Matches `environment.env`; `local` is left out so dev machines don't report. */
export const BUGSNAG_ENABLED_RELEASE_STAGES = ['development', 'QA', 'production'];

export interface StartBugsnagOptions {
  apiKey: string;
  releaseStage: string;
  appVersion: string;
  /** Applied to page and request paths before sending, e.g. spotlight-ui's `stripLocationPrefix`. */
  normalizePath?: PathNormalizer;
}

/**
 * Starts Bugsnag. Called from `main.ts` before Angular bootstraps so errors during
 * bootstrap and login are reported too.
 */
export function startBugsnag({ apiKey, releaseStage, appVersion, normalizePath }: StartBugsnagOptions): void {
  if (!apiKey || Bugsnag.isStarted()) {
    return;
  }

  Bugsnag.start({
    apiKey,
    releaseStage,
    appVersion: appVersion || undefined,
    enabledReleaseStages: BUGSNAG_ENABLED_RELEASE_STAGES,
    autoTrackSessions: false,
    maxBreadcrumbs: 100,
    maxEvents: 100,
    trackInlineScripts: false,
    onError: (event) => scrubBugsnagEvent(event, normalizePath),
    onBreadcrumb: attachTraceIdToBreadcrumb
  });
}
